import { CardComponent } from '@checkout/feature-card';
import { DirectDebitComponent } from '@checkout/feature-direct-debit';
import { IneligibleComponent } from '@checkout/feature-ineligible';
import { LandingComponent } from '@checkout/feature-landing';
import { OrderConfirmationComponent } from '@checkout/feature-order-confirmation';
import { PaymentMethodComponent } from '@checkout/feature-payment-method';
import { PersonalDetailsComponent } from '@checkout/feature-personal-details';
import { CmsComponentMapping } from '@domgen/dgx-fe-cms';
import { MarketingPreferencesComponent } from 'libs/checkout/feature-marketing-preferences/src/lib/pages/marketing-preferences/marketing-preferences.component';

export const CHECKOUT_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  'dgx-checkout:pages/card': CardComponent,
  'dgx-checkout:pages/direct-debit': DirectDebitComponent,
  'dgx-checkout:pages/index': LandingComponent,
  'dgx-checkout:pages/ineligible': IneligibleComponent,
  'dgx-checkout:pages/marketing-preferences': MarketingPreferencesComponent,
  'dgx-checkout:pages/order-confirmation': OrderConfirmationComponent,
  'dgx-checkout:pages/payment-method': PaymentMethodComponent,
  'dgx-checkout:pages/personal-details': PersonalDetailsComponent,
};
